import { Injectable } from '@angular/core';
import { UserResponseDTO } from '@app/modules/user/interfaces/user-response-dto.interface';

import { BaseGuard } from './baseGuard.guard';

@Injectable()
export class SuperUserTenantGuard extends BaseGuard {
  protected override check(user: UserResponseDTO, isLogged: boolean): boolean {
    if (!isLogged) {
      this.router.navigate(['']);

      return false;
    }

    const token = this.authTokenSignalHandler.getToken();
    const tokenDecoded = this.tokenHandler.run(token().accessToken);
    const keysOfTokenDecoded = Object.keys(tokenDecoded.tokenDecoded);
    if (
      !keysOfTokenDecoded.includes('tenantId') ||
      !tokenDecoded.tokenDecoded.tenantId
    ) {
      this.sessionDeleter.run(true);

      return false;
    }

    if (user.defaultRoleId !== 0) {
      this.router.navigate(['/analytics/overview']);

      return false;
    }

    return true;
  }
}
